module.exports = {
          srcSet: __webpack_public_path__ + "public/f989372607a2ffde3c799b505f02cc52-40.png"+" 40w",
          images:[ {path: __webpack_public_path__ + "public/f989372607a2ffde3c799b505f02cc52-40.png",width: 40,height: 40}],
          src: __webpack_public_path__ + "public/f989372607a2ffde3c799b505f02cc52-40.png",
          toString:function(){return __webpack_public_path__ + "public/f989372607a2ffde3c799b505f02cc52-40.png"},
          
          width: 40,
          height: 40
        }